import authRepository from "../repositories/AuthRepository";

class AuthService {
    constructor() {
        this.KEY = "OATH_TOKEN";
        this.AUTH_URL = process.env.VUE_APP_GOOGLE_AUTH_URL;
        this.VALIDATE_TOKEN_URL = process.env.VUE_APP_GOOGLE_URL;
        this.currentUser = null;
        this.permissions = null;
    }

    getToken() {
        return localStorage.getItem(this.KEY);
    }

    storeToken(token) {
        localStorage.setItem(this.KEY, token);
    }

    getAccessCode() {
        const url = new URL(window.location.href);
        const fragment = url.search;

        const params = new URLSearchParams(fragment);
        return params.get("code");
    }

    async getTokenFromCode(code) {
        const token = authRepository.generateToken(code);
    }

    async authenticateWithCode(code) {
        try {
            const user = await authRepository.generateToken(code);

            if (!user) {
                console.log("error in auth");
            }

            this.storeToken(user.token);
            this.currentUser = user.profile;
            this.permissions = user.permissions;
        } catch (error) {
            console.log("error!");
            throw error;
            //   authService.removeToken();
        }
    }

    async authenticateWithToken(token) {
        const user = await authRepository.loginWithToken(token);

        this.currentUser = user.profile;
        this.permissions = user.permissions;

        if (user.saveToken) {
            this.storeToken(user.token);
        }
    }

    getUserName() {
        return this.currentUser.name;
    }

    hasPermission(permissionName) {
        return this.permissions.includes(permissionName);
    }

    removeToken() {
        localStorage.removeItem(this.KEY);
    }

    isDarkMode() {
        return this.currentUser.settings?.darkMode ?? false;
    }

    updateSettings(settings) {
        this.currentUser.settings = settings;
    }
}

export default new AuthService();
